"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
exports.PricingFicoStrategy = exports.PricingCreditScoreSource = void 0;
/** @TranslateToPython */
var PricingCreditScoreSource;
(function (PricingCreditScoreSource) {
    PricingCreditScoreSource["EXPERIAN_FICO_F9"] = "EXPERIAN_FICO_F9";
    PricingCreditScoreSource["TRANSUNION_FICO_F9"] = "TRANSUNION_FICO_F9";
    PricingCreditScoreSource["TRANSUNION_FICO_F8"] = "TRANSUNION_FICO_F8";
    PricingCreditScoreSource["EQUIFAX_FICO_F9"] = "EQUIFAX_FICO_F9";
    PricingCreditScoreSource["TRIBUREAU_FICO_F9"] = "TRIBUREAU_FICO_F9";
    PricingCreditScoreSource["EXPERIAN_VANTAGE_V4"] = "EXPERIAN_VANTAGE_V4";
})(PricingCreditScoreSource || (exports.PricingCreditScoreSource = PricingCreditScoreSource = {}));
/**
 * How the pricing credit score is chosen between the primary and secondary applicants.
 *
 * @TranslateToPython
 */
var PricingFicoStrategy;
(function (PricingFicoStrategy) {
    PricingFicoStrategy["MIN_FICO"] = "MIN_FICO";
    PricingFicoStrategy["MAX_FICO"] = "MAX_FICO";
})(PricingFicoStrategy || (exports.PricingFicoStrategy = PricingFicoStrategy = {}));
